import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { RichMediaState, User } from '@bonusly/common-action-input';
import { useHttpClient } from '@bonusly/http-client';
import { useCurrentUser } from '@bonusly/who-am-i';

import { mapToUsers } from '../utils/users';

// @TODO delete this duplicated function from `give-box`
export const useFetchUsers = (params = {}) => {
	const http = useHttpClient('v2');
	const currentUser = useCurrentUser();
	const queryClient = useQueryClient();

	return useCallback(
		async ({ query, state }: { query: string; state: RichMediaState }): Promise<User[]> => {
			const taggedUsers = [...state.mentions, ...state.recipients];
			const search = query.trim();

			const buildUserList = (data: any) => {
				return mapToUsers(data).filter((user) => {
					return user.id !== currentUser.id && taggedUsers.every((tagged) => tagged.id !== user.id);
				});
			};

			if (!search) {
				const data = await queryClient.fetchQuery(['recipients'], () => http.get('/recipients'), {
					staleTime: Infinity,
				});

				return buildUserList(data);
			}

			const all = { search, search_usergroups: false, ...params };

			const data = await queryClient.fetchQuery(['rich-users', all], () => {
				return http.get('/users/autocomplete', {
					baseURL: (http.defaults.baseURL || '').replace('/v2', '/v1'),
					params: all,
				});
			});

			return buildUserList(data);
		},
		[currentUser, http, params, queryClient]
	);
};
